import React from 'react';

import spinner from '../components/images/spinner.gif';
function Spinner() {
	return <img src={spinner} className="spinner" alt="" />;
}

export default Spinner;
